module.exports = __webpack_public_path__ + "img/cmi_logo.a98f4442.png";